import {Component, Input} from '@angular/core';
import {NgxChartsModule} from '@swimlane/ngx-charts';



@Component({
    selector: 'app-summary-chart',
    templateUrl: './summary-chart.component.html',
    styleUrls: ['./summary-chart.component.scss'],
    standalone: true,
    imports: [
        NgxChartsModule
    ]
})
export class SummaryChartComponent {

    chartData: any[] = [];
    view: [number, number] = [0, 300];

    // single: any[];
    // multi: any[];
    // options
    showXAxis = true;
    showYAxis = true;
    gradient = false;
    showLegend = false;
    showXAxisLabel = false;
    xAxisLabel = 'Country';
    showYAxisLabel = false;
    yAxisLabel = 'Population';
    colorScheme = 'vivid';

    @Input() set data(data: any[]) {

        this.chartData = data;
    }

    onSelect(event) {
        console.log(event);
    }

}
